import { useState } from 'react'

import { ScrollMode, SpreadMode } from '../../PdfViewer.constants'
import { checkIsPdfViewerPageScrollMode } from '../../PdfViewer.utils'

import { PDF_VIEWER_ROTATION_STEP } from './usePdfViewerViewMode.constants'

export function usePdfViewerViewMode({ pdfViewerRef, singlePage = false }) {
  const initialScrollMode = singlePage ? ScrollMode.PAGE : ScrollMode.VERTICAL

  const [scrollMode, setScrollMode] = useState(initialScrollMode)
  const [spreadMode, setSpreadMode] = useState(SpreadMode.NONE)
  const [rotation, setRotation] = useState(0)

  function handleChangeScrollMode(nextScrollMode) {
    setScrollMode(nextScrollMode)

    pdfViewerRef.current.scrollMode = nextScrollMode
  }

  function handleChangeSpreadMode(nextSpreadMode) {
    setSpreadMode(nextSpreadMode)

    pdfViewerRef.current.spreadMode = nextSpreadMode
  }

  function rotatePages(step) {
    const pdfViewer = pdfViewerRef.current

    pdfViewer.pagesRotation += step

    setRotation(pdfViewer.pagesRotation)
  }

  function handleRotateClockwise() {
    rotatePages(PDF_VIEWER_ROTATION_STEP)
  }

  function handleRotateCounterClockwise() {
    rotatePages(-PDF_VIEWER_ROTATION_STEP)
  }

  function resetViewMode() {
    setScrollMode(initialScrollMode)
    setSpreadMode(SpreadMode.NONE)
    setRotation(0)

    pdfViewerRef.current.scrollMode = initialScrollMode
  }

  return {
    isPageScrollMode: checkIsPdfViewerPageScrollMode(scrollMode),
    resetViewMode,
    rotation,
    viewModeProps: {
      scrollMode,
      spreadMode,
      onChangeScrollMode: handleChangeScrollMode,
      onChangeSpreadMode: handleChangeSpreadMode,
      onRotateClockwise: handleRotateClockwise,
      onRotateCounterClockwise: handleRotateCounterClockwise,
    },
  }
}
